module.exports = {"foo":"hahahahah ES","hello":"hola {{name}}","Árboles":"Árboles","Raservas":"Raservas","Especies":"Especies","Ranking":"Ranking","Acerca de":"Acerca de","ADMINISTRACIÓN":"ADMINISTRACIÓN","Países":"Países","Ecosistemas":"Ecosistemas","Reservas":"Reservas","Seriales":"Seriales","Últimas 72h":"Últimas 72h"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/es.json
// module id = 7ucu
// module chunks = 1